import * as React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { motion } from "framer-motion";

import SMS_1 from "../assets/projects/SMS_1.jpg";
import SMS_2 from "../assets/projects/SMS_2.jpg";
import SMS_3 from "../assets/projects/SMS_3.png";
import BOT_1 from "../assets/projects/BOT_1.png";
import BOT_2 from "../assets/projects/BOT_2.png";
import HSR_1 from "../assets/projects/HSR_1.png";
import HSR_2 from "../assets/projects/HSR_2.png";
import BSW_1 from "../assets/projects/BSW_1.png";
import BSW_2 from "../assets/projects/BSW_2.png";
import BSW_3 from "../assets/projects/BSW_3.png";
import BSW_4 from "../assets/projects/BSW_4.png";
import BSW_5 from "../assets/projects/BSW_5.png";
import BSW_6 from "../assets/projects/BSW_6.png";
import BSW_7 from "../assets/projects/BSW_7.png";

import {
  Typography,
  Box,
  Container,
  Grid,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  IconButton,
  Button,
  Card,
  CardActionArea,
  Chip
} from "@mui/material/";
import CloseIcon from "@mui/icons-material/Close";
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

const projects = [
  {
    images: [SMS_1, SMS_2, SMS_3],
    name: "Salinity & pH Monitoring",
    chips: ["Flutter", "Arduino", "Firebase"],
    description:
      "The Salinity and pH Monitoring System (SMS) is an IoT technology that integrates into an Android app to monitor environmental conditions in water bodies like tanks and ponds. It uses two sensors to measure water quality based on salinity and pH levels, which are displayed on an LCD monitor and mobile application.",
    github: "https://github.com/haritsrhn/Salinity-and-pH-Monitoring-System",
    youtube: "https://youtu.be/pE1007CXaPQ?si=vUE1r1geBdpzbANR",
  },
  {
    images: [BOT_1, BOT_2],
    name: "Campus Bites Bot",
    chips: ["Java", "SQLite"],
    description:
      "Campus Bites Bot is a Telegram bot designed for UUM students to enhance efficiency and user satisfaction by providing a food search system in the cafe, allowing easy access to items, locations, and prices.",
    github: "https://github.com/haritsrhn/Group-Project-Telegram-Bot",
    youtube: "https://youtu.be/k0YJl4L5WPo",
  },
  {
    images: [HSR_1, HSR_2],
    name: "Homestay Raya App",
    chips: ["Flutter", "PHP", "MySQL"],
    description:
      "The mobile application, created using Flutter, is designed to fulfill the final assignment of a mobile programming course, enabling users to rent and manage homestays, and implementing CRUD functions.",
    github: "https://github.com/haritsrhn/homestayraya-mobileapp-v0.1.2",
    youtube: "https://youtu.be/zD0tp_wxiOo?si=CP97fz-Zh2bJtK4r",
  },
  {
    images: [BSW_1, BSW_2, BSW_3, BSW_4, BSW_5, BSW_6, BSW_7],
    name: "Book Store Web",
    chips: ["HTML", "CSS", "PHP"],
    description:
      "The website, created by a group of two, aims to complete the final web engineering course assignment by implementing CRUD functions.",
    github: "https://github.com/haritsrhn/simple-online-bookstore-web",
    youtube: "",
  },
];

export default function Projects() {
  const [open, setOpen] = React.useState(false);
  const [selectedProject, setSelectedProject] = React.useState(null);

  const handleOpenDialog = (project) => {
    setSelectedProject(project);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedProject(null);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    appendDots: dots => (
      <Box sx={{ bottom: -30 }}>
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </Box>
    ),
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] }
    }
  };

  return (
    <Box
      id="projects"
      sx={{
        py: { xs: 8, md: 12 },
        position: "relative",
      }}
    >
      <Container maxWidth="lg">
        <Box mb={6} display="flex" justifyContent="space-between" alignItems="flex-end">
          <Typography variant="h2" sx={{ color: "text.primary" }}>
            Projects
          </Typography>
        </Box>

        <Box
          component={motion.div}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <Grid container spacing={3}>
            {projects.map((project, index) => (
              <Grid item xs={12} md={6} key={index}>
                <motion.div variants={itemVariants} style={{ height: '100%' }}>
                  <Card sx={{ height: "100%", overflow: "hidden", position: "relative" }}>
                    <CardActionArea 
                      onClick={() => handleOpenDialog(project)}
                      disableRipple
                      sx={{ 
                        height: "100%", 
                        display: "flex", 
                        flexDirection: "column", 
                        alignItems: "flex-start",
                        justifyContent: "flex-start",
                        "&:hover .project-image": {
                          transform: "scale(1.05)",
                        },
                        "&:hover .arrow-icon": {
                          transform: "translate(4px, -4px)",
                          color: "primary.main"
                        }
                      }}
                    >
                      {/* Image Bento Header */}
                      <Box 
                        sx={{ 
                          width: "100%",
                          height: { xs: 200, sm: 260 }, 
                          bgcolor: "#000",
                          overflow: "hidden",
                          position: "relative"
                        }}
                      >
                        <img
                          className="project-image"
                          src={project.images[0]}
                          alt={project.name}
                          loading="lazy"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            transition: "transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)",
                            opacity: 0.8
                          }}
                        />
                        <Box sx={{ position: "absolute", top: 16, right: 16 }}>
                           <Box 
                             className="arrow-icon"
                             aria-hidden="true"
                             sx={{ 
                               width: 32, height: 32, 
                               borderRadius: "50%", 
                               bgcolor: "rgba(0,0,0,0.5)", 
                               backdropFilter: "blur(10px)",
                               display: "flex", alignItems: "center", justifyContent: "center",
                               color: "#fff",
                               transition: "all 0.3s ease"
                             }}
                           >
                             <ArrowOutwardIcon fontSize="small" />
                           </Box>
                        </Box>
                      </Box>

                      {/* Content Bento Body */}
                      <Box sx={{ p: 3, width: "100%" }}>
                        <Typography 
                          variant="h4" 
                          color="text.primary"
                          sx={{ mb: 2 }}
                        >
                          {project.name}
                        </Typography>
                        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap", mb: 2 }}>
                          {project.chips.map((chip, i) => (
                            <Chip key={i} label={chip} size="small" />
                          ))}
                        </Box>
                        <Typography variant="body2" sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                          {project.description}
                        </Typography>
                      </Box>
                    </CardActionArea>
                  </Card>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Bento Dialog Popup */}
        <Dialog 
          open={open} 
          onClose={handleCloseDialog} 
          maxWidth="md" 
          fullWidth
          scroll="paper"
          PaperProps={{
            sx: {
              m: { xs: 2, md: 4 },
              maxWidth: "800px !important",
              borderRadius: "24px",
              border: `1px solid ${theme => theme.palette.divider}`,
              bgcolor: "background.paper",
            }
          }}
        >
          <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: { xs: 3, md: 4 }, pb: { xs: 2, md: 2 } }}>
            <Typography variant="h3" color="text.primary">
              {selectedProject?.name}
            </Typography>
            <IconButton onClick={handleCloseDialog} sx={(theme) => ({ bgcolor: theme.palette.mode === 'dark' ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.05)" })}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers sx={(theme) => ({ p: { xs: 3, md: 4 }, borderColor: theme.palette.divider })}>
            {selectedProject && (
              <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  {selectedProject.chips.map((chip, i) => (
                    <Chip key={i} label={chip} />
                  ))}
                </Box>

                <Box sx={(theme) => ({ 
                  borderRadius: "16px",
                  overflow: "hidden",
                  border: `1px solid ${theme.palette.divider}`,
                  bgcolor: theme.palette.mode === "dark" ? "#000" : "#fff",
                  pb: 4 // Space for dots
                })}>
                  <Slider {...settings}>
                    {selectedProject.images.map((image, index) => (
                      <Box key={index} sx={{ outline: 'none', height: { xs: 250, md: 450 } }}>
                        <img
                          src={image}
                          alt={`${selectedProject.name} screenshot ${index + 1}`}
                          loading="lazy"
                          style={{ 
                            width: "100%",
                            height: "100%",
                            objectFit: "contain" 
                          }}
                        />
                      </Box>
                    ))}
                  </Slider>
                </Box>
                
                <Typography variant="body1">
                  {selectedProject.description}
                </Typography>
              </Box>
            )}
          </DialogContent>
          
          <DialogActions sx={{ p: { xs: 3, md: 4 }, pt: { xs: 2, md: 2 }, justifyContent: "flex-start", gap: 2 }}>
            {selectedProject && (
              <>
                <Button
                  variant="contained"
                  href={selectedProject.github}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GitHub Repository
                </Button>
                {selectedProject.youtube && (
                  <Button
                    variant="outlined"
                    href={selectedProject.youtube}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Watch Demo
                  </Button>
                )}
              </>
            )}
          </DialogActions>
        </Dialog>
      </Container>
    </Box>
  );
}
